<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;"></span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="16">
        <el-card class="box-card">
          <div class="text item">
            <el-row>
              <el-col :span="5">
                <el-input
                    placeholder="请输入角色名称"
                    v-model="nickName">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-col>
              <el-col :span="11">
                <el-button type="primary theme-btn" class="btn" @click.native="searchRole">查询</el-button>
                <el-button type="info" class="btn" @click.native="rest">重置</el-button>
                <el-button type="warning" class="btn" @click.native="getJurisdictionTree">新增</el-button>
              </el-col>
            </el-row>
            <!-- <div>
                <el-date-picker
                v-model="value1"
                type="week"
                format="yyyy/MM/dd  HH:mm:ss"
                placeholder="选择周">
                </el-date-picker>
                <el-button type="primary theme-btn" class="btn">查询</el-button>
                <el-button type="warning" class="btn" @click.native="roleAdd=true">新增</el-button>
            </div> -->

            <!-- 表格 -->
            <el-table style="width: 100%"
                      :data="tableData"
                      class="table-content">


              <el-table-column label="编号" prop="index"></el-table-column>
              <el-table-column label="角色名称" prop="nickName"></el-table-column>
              <el-table-column label="角色描述">
                <template slot-scope="scope">
                  <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.description">
                    <div class='ellipsis' slot="reference">{{ scope.row.description }}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" width="174">
                <template slot-scope="scope">
                  <el-button size="mini" @click="getStatusTree(scope.row)" class="table-compile">编辑</el-button>
                  <el-button size="mini" type="danger" @click="removeRole(scope.$index, scope.row)" class="table-del">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>

      </el-col>
    </el-row>

    <!-- 弹框 -->
    <!-- 角色管理-编辑弹框 -->
    <el-dialog
        title="角色管理-编辑"
        :visible.sync="roleComplie"
        width="20%"
        center
        class="compile-box">
      <el-row>
        <el-form ref="roleComplieForm" label-width="80px" class="complie-form">
          <el-form-item label="角色名称">
            <el-input v-model="complieName" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入描述内容"
                v-model="complieDescribe">
            </el-input>
          </el-form-item>

          <el-form-item label="角色权限" class="jurisdiction">

            <!-- 审核管理 -->
            <el-tree
                :default-checked-keys="complieSelectedTree"
                node-key="id"
                ref="compileTree"
                :data="roleComplieDataArr"
                :props="roleComplieProps"
                show-checkbox
                @check-change="complieSelectedFn">
            </el-tree>
            <!-- <el-checkbox label="文章发布" class="checkbox complie-checkbox"></el-checkbox> -->

          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button @click="complieRole" class="alertBtn compile theme-btn">保 存</el-button>
                <el-button @click="roleComplie = false" class="alertBtn del ">返 回</el-button>
            </span>
    </el-dialog>

    <!-- 角色管理-新增弹框 -->

    <el-dialog
        title="角色管理-新增"
        :visible.sync="roleAdd"
        width="20%"
        center
        class="compile-box">
      <el-row>
        <el-form ref="roleAddForm" label-width="80px" class="complie-form">
          <el-form-item label="角色名称">
            <el-input v-model="roleName" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入描述内容"
                v-model="roleDescribe">
            </el-input>
          </el-form-item>

          <el-form-item label="角色权限" class="jurisdiction">
            <!-- 审核管理 -->
            <el-tree
                node-key="id"
                ref="tree"
                :data="roleAddDataArr"
                :props="roleAddProps"
                show-checkbox
                @check-change="addSelectedFn">
            </el-tree>
            <!-- <el-checkbox label="文章发布" class="checkbox complie-checkbox"></el-checkbox> -->

          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button @click="saveFun" class="alertBtn compile theme-btn">保 存</el-button>
                <el-button @click="roleAdd = false" class="alertBtn del ">返 回</el-button>
            </span>
    </el-dialog>


  </div>
</template>
<script>
import Head from '@/components/header/head.vue'

export default {
  data() {
    return {
      compileTree: '',
      id: '', // 存储当前行的id已便传值
      tableData: [],
      nickName: '',    // 名称查询
      complieName: '',
      complieDescribe: '',
      complieSelectedTree: [],     // 存放编辑点击的菜单id
      defaultTree: [],
      roleComplieSelectedTree: [],    // 角色权限菜单树
      roleComplieSelected: [],       // 角色权限已选择数据
      roleComplieData: [],           // 角色菜单数据
      roleComplieDataArr: [   // 审核弹框联级菜单
      ],
      // 审核管理
      roleComplieProps: {
        children: 'children',
        label: 'displayName'
      },
      roleComplie: false,  // 角色管理编辑弹框
      // 角色管理新增数据
      roleName: '',
      roleDescribe: '',
      addSelectedArr: [],
      roleAddDataArr: [],
      // 审核管理
      roleAddProps: {
        children: 'children',
        label: 'displayName'
      },
      roleAdd: false
    }
  },

  components: {
    Head
  },
  methods: {
    // 重置数据
    rest() {
      this.nickName = ""
      this.searchRole()
    },
    // 编辑选择角色权限
    complieSelectedFn(data, status) {   // 添加选择的权限
      if (status) {
        if (data.children && data.children.length > 0) {
          data.children.forEach((item, index) => {
            this.complieSelectedTree.push(item.id)
          })
          // console.log('parentselectcomplieSelectedTree')
          // console.log(data.id)
        }
        this.complieSelectedTree.push(data.id)
      } else {

        // console.log('delcomplieSelectedTree')
        // console.log(this.complieSelectedTree.indexOf(data.id))
        this.complieSelectedTree.splice(this.complieSelectedTree.indexOf(data.id), 1)
        if (data.children && data.children.length > 0) {
          data.children.forEach((item, index) => {
            // console.log('item')
            // console.log(item)
            this.complieSelectedTree.splice(this.complieSelectedTree.indexOf(item.id), 1)
          })
        }
      }

    },
    // 新增添加选择的权限
    addSelectedFn(data, status) {
      // this.addSelectedArr.push(data.id)
      if (status) {
        if (data.children && data.children.length > 0) {
          data.children.forEach((item, index) => {
            this.addSelectedArr.push(item.id)
          })
        }
        this.addSelectedArr.push(data.id)
      } else {
        if (data.children && data.children.length > 0) {
          // console.log('children')
          // console.log(data.children)
          data.children.forEach((item, index) => {
            this.addSelectedArr.splice(this.addSelectedArr.indexOf(item.id), 1)
          })
        }
        this.addSelectedArr.splice(this.addSelectedArr.indexOf(data.id), 1)
      }
      // console.log('addSelectedArr')
      // console.log(this.addSelectedArr)
    },
    // 点击新增保存
    saveFun() {
      this.roleAdd = false
      this.axiosPost('/web/role/add', {
        nickName: this.roleName,
        description: this.roleDescribe,
        menuId: this.addSelectedArr
      }).then((res) => {
        if (res.code == 200) {
          this.searchRole();
          this.$message({
            showClose: true,
            message: res.message,
            type: 'success'
          });
        }
      })
    },
    // 删除
    removeRole(index, row) {
      let id = row.id
      this.axiosPost(`/web/role//deleteById/${id}`).then((res) => {
        // console.log('删除')
        // console.log(res)
        let status = res.code == 200 ? 'success' : 'error'
        if (res.code == 200) {
          this.searchRole()

        }
        this.$message({
          showClose: true,
          message: res.message,
          type: status
        });
      })
    },
    // 角色编辑保存
    complieRole() {
      this.roleComplie = false
      this.axiosPost('/web/role/update',
          {
            nickName: this.complieName,
            id: this.id,
            description: this.complieDescribe,
            menuId: this.complieSelectedTree
            // menuId:[]
          }
      ).then((res) => {
        if (res.code == 200) {
          this.searchRole()
          this.$message({
            showClose: true,
            message: res.message,
            type: 'success'
          });

        }
      })
    },
    // 点击新增获得权限树
    getJurisdictionTree() {
      this.roleAdd = true
      this.roleName = '',
          this.roleDescribe = ''
      this.axiosGet('/web/menu/findTreeAll').then((res) => {
        this.roleAddDataArr = res.data
      })
    },
    // 搜索
    searchRole() {
      this.axiosGet(`/web/role/findList/?nickName=${this.nickName}`,
      ).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            item.index = parseInt(index + 1)
          })
          this.tableData = res.data
          this.roleComplieSelected = res.data.menuId
        }
      })
    },
    // 点击编辑
    getStatusTree(row) {
      this.complieSelectedTree = row.menuId
      this.roleComplie = true
      this.complieName = row.nickName
      this.complieDescribe = row.description

      this.id = row.id
      this.axiosGet('/web/menu/findTreeAll').then((res) => {
        if (res.code == 200) {
          this.roleComplieDataArr = res.data
        }
      })

    }

  },
  mounted() {
    this.searchRole()
  }
}
</script>
<style lang="less" scoped>
.btn {
  width: 96px;
  height: 42px;
  margin-left: 43px;
}

.table-compile {
  background-color: #1A80FC;
  width: 72px;
  height: 30px;
  color: #ffffff;
}

.table-del {
  width: 72px;
  height: 30px;
  background: #D1E6FF;
  color: #1A80FC;
  border-color: #D1E6FF;
}

// 弹框
.compile-box {
  .checkbox {
    display: block;
  }
}

// button
.alertBtn {
  height: 30px;
  line-height: 6px;
}

.compile {
  color: #ffffff;
}

.del {
  color: #1A80FC;
}
</style>
